import React from 'react';
import HeroBanner from './accoutingServicesComponents/hero-banner';
import AccountingPackages from './accoutingServicesComponents/accouting-packages';
import usePageTitle from '../usePageTitle';

export default function AccountingServices() {
    usePageTitle({
        title: 'TaxObey | Accounting Services',
        description: 'Review TaxObey accounting service packages for businesses that need bookkeeping, compliance support, and reliable financial records.',
        path: '/accounting-services',
    });

    return (
        <div className="accounting-services">
            <HeroBanner />
            <AccountingPackages />
        </div>
    );
}